/**
 * `sizes` values for card thumbnails rendered through `next/image fill`.
 *
 * Without one, `fill` defaults to `100vw` and the browser picks the largest
 * srcset candidate — Lighthouse caught 215–658px card thumbs fetched at
 * `w=3840` (FRONT-532). Breakpoints mirror `--carousel-items` in
 * `app/globals.css` (768 / 1280) and the 2/3/4-column card grids; the desktop
 * cap covers the widest grid cell. Callers with a wider layout pass their own.
 */
export const CARD_IMAGE_SIZES = {
  landscape: '(max-width: 767px) 50vw, (max-width: 1279px) 33vw, 360px',
  landscapeLarge: '(max-width: 767px) 100vw, (max-width: 1279px) 33vw, 400px',
  portrait: '(max-width: 767px) 50vw, (max-width: 1279px) 25vw, 240px',
  /** `.tbCard.layout-compact .tb-thumb` is a fixed 200px column. */
  compact: '200px',
} as const;
